import { Environment } from 'react-relay';

type BillingAddress = {
    name: string | null;
    line1: string | null;
    line2: string | null;
    city: string | null;
    state: string | null;
    zipCode: string | null;
    country: string | null;
};

export async function getConfirmedTransactionBillingAddress(
    environment: Environment,
    transactionId: string
): Promise<BillingAddress | null> {
    const { fetchConfirmedTransactionBillingAddress } = await import(
        /* webpackChunkName: "confirmationBillingAddress" */
        './fetchConfirmedTransactionBillingAddress'
    );
    const billingAddress = await fetchConfirmedTransactionBillingAddress(environment, {
        transactionId,
    });
    if (!billingAddress) {
        return null;
    }
    return {
        name: `${billingAddress.firstName} ${billingAddress.lastName}`,
        line1: billingAddress.line1,
        line2: billingAddress.line2,
        city: billingAddress.city,
        state: billingAddress.state,
        zipCode: billingAddress.zipCode,
        country: billingAddress.country,
    };
}

export function getConfirmedTransactionId(): string | null {
    if (typeof location === undefined) {
        return null;
    }
    const pathnameMatch = location.pathname?.match(/\/checkout\/confirmation\/.+\/(\d+)/);
    const transactionId = pathnameMatch?.[1];
    return transactionId || null;
}
